import type { GridColumnSpan } from '@athena-lib/Grid';
import type { GridRowSpan } from '@athena-lib/Grid/types';

export type Layout = '2' | '3' | '4' | '5'; // Number of images
type GridItemSpansPerLayout = {
  [key in Layout]: {
    colSpan: GridColumnSpan[];
    rowSpan?: GridRowSpan[];
    aspectClass: string[];
  };
};

export const getGridItemSpansPerLayout = (reverseLayout: boolean): GridItemSpansPerLayout => {
  if (!reverseLayout) {
    return {
      2: { colSpan: [7, 5], aspectClass: ['md:aspect-7/5', 'md:aspect-square'] },
      3: {
        colSpan: [8, 4, 4],
        rowSpan: [2, 1, 1],
        aspectClass: ['md:aspect-square', 'md:aspect-square', 'md:aspect-square'],
      },
      4: {
        colSpan: [7, 5, 5, 7],
        aspectClass: ['md:aspect-7/5', 'md:aspect-square', 'md:aspect-square', 'md:aspect-7/5'],
      },
      5: {
        colSpan: [6, 3, 3, 3, 3],
        rowSpan: [2, 1, 1, 1, 1],
        aspectClass: [
          'md:aspect-square',
          'md:aspect-square',
          'md:aspect-square',
          'md:aspect-square',
          'md:aspect-square',
        ],
      },
    };
  } else {
    return {
      2: { colSpan: [5, 7], aspectClass: ['md:aspect-square', 'md:aspect-7/5'] },
      3: {
        colSpan: [4, 8, 4],
        rowSpan: [1, 2, 1],
        aspectClass: ['md:aspect-square', 'md:aspect-square', 'md:aspect-square'],
      },
      4: {
        colSpan: [5, 7, 7, 5],
        aspectClass: ['md:aspect-square', 'md:aspect-7/5', 'md:aspect-7/5', 'md:aspect-square'],
      },
      5: {
        colSpan: [3, 3, 6, 3, 3],
        rowSpan: [1, 1, 2, 1, 1],
        aspectClass: [
          'md:aspect-square',
          'md:aspect-square',
          'md:aspect-square',
          'md:aspect-square',
          'md:aspect-square',
        ],
      },
    };
  }
};
